// @flow
const noop = () => {}
noop.return = <T>(val: T) => (): T => val
export default noop
